<template>
  <ProductPricePage
    :product="data.product"
    :product-data="data.productData"
    :subscription="subscription"
  >
    <NuxtPage
      :product="data.product"
      :product-data="data.productData"
      :subscription="subscription"
    />
  </ProductPricePage>
</template>

<script setup lang="ts">
import ProductPricePage from '~/components/market/ProductPricePage.vue'
import {
  BLACK_MASS,
  MARKET,
  SUBSCRIPTION_PRICE_ASSESSMENTS_BLACK_MASS,
} from '~/constants/services/constants'
import blackMassData from '~/constants/price-assessments/unauthorized/black-mass'

const subscription = SUBSCRIPTION_PRICE_ASSESSMENTS_BLACK_MASS
const data = {
  product: BLACK_MASS,
  productData: blackMassData,
  subscription,
}

definePageMeta({ layout: 'services' })
const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${BLACK_MASS.name} Prices`,
  description: `Access real-time and historic black mass prices from Benchmark, with expert supply/demand analysis and market commentary.`,
})
useHead(seo)
</script>
